"use client";
import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const [selected, setSelected] = useState("");

  const handleClick = (value) => {
    console.log("selected sidebar item>>", value);
    setSelected(value);
  };

  return (
    <div className="w-64 bg-gray-800 text-gray-100 p-6 space-y-4">
      <h2 className="text-2xl font-semibold mb-6">cQube</h2>

      <ul className="space-y-2">
        <li
          className={
            location.pathname === "/EcommerceBot/integration"
              ? "bg-gray-700"
              : selected === "Integrations"
              ? "bg-gray-900 rounded-md"
              : ""
          }
        >
          <Link
            to="/EcommerceBot/integration"
            className="block p-2 hover:bg-gray-700 rounded"
            onClick={() => handleClick("Integrations")}
          >
            Integrations
          </Link>
        </li>
        <li
          className={
            location.pathname === "/EcommerceBot/endpoint"
              ? "bg-gray-700"
              : selected === "Endpoints"
              ? "bg-gray-900 rounded-md"
              : ""
          }
        >
          <Link
            to="/EcommerceBot/endpoint"
            className="block p-2 hover:bg-gray-700 rounded"
            onClick={() => handleClick("Endpoints")}
          >
            End Points
          </Link>
        </li>
        <li
          className={
            location.pathname === "/EcommerceBot/datamodel"
              ? "bg-gray-700"
              : selected === "Datamodels"
              ? "bg-gray-900 rounded-md"
              : ""
          }
        >
          <Link
            to="/EcommerceBot/datamodel"
            className="block p-2 hover:bg-gray-700 rounded"
            onClick={() => handleClick("Datamodel")}
          >
            Data Model
          </Link>
        </li>
        <li
          className={
            location.pathname === "/e-commerceAI"
              ? "bg-gray-700"
              : selected === "back"
              ? "bg-gray-900 rounded-md"
              : ""
          }
        >
          <Link
            to="/e-commerceAI"
            className="block p-2 hover:bg-gray-700 rounded"
            onClick={() => handleClick("back")}
          >
            Back
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Header;
